<template lang="pug">
include /@ibkr/lib.common/src/icon/basic
include /@ibkr/lib.common/src/icon/arrow
div(class="border-bottom insety-16" id="search")
    ib-row(:class="{ 'pb-16': !$media.xl }")
        ib-col(class="xl3")
            p(
                class="insety-16", 
                :class="{'insetx-4': !$media.m, 'insetx-8': $media.l, 'insetx-16': $media.xl}"
            )
                span(
                    class="info", 
                    :class="{'start-0': !$media.m}"
                )
                    +icon-basic-info_filled
                    span(class="tooltext", v-if="selectedTab === 'products'") {{ $t('search_product') }}
                    span(class="tooltext", v-if="selectedTab === 'exchanges'") {{ $t('search_exchange') }}
                    span(class="tooltext", v-if="selectedTab === 'contracts'") {{ $t('search_contracts') }}
                span(v-if="selectedTab === 'products'") {{ $t('symbol/name') }}
                span(v-if="selectedTab === 'exchanges'") {{ $t('exchanges') }}
                span(v-if="selectedTab === 'contracts'") {{ $t('contract') }}
        ib-col(
            v-if="selectedTab === 'products' || selectedTab === 'contracts'",
            class="xl9 search-bar",
        )
            ib-form(class="ticker flex-flex")
                ib-field(
                    v-model="selectedProduct",
                    @input="checkValidation(selectedProduct)",
                    class="ticker-field mb50",
                    :placeholder="$t('optional')",
                    uppercase=true,
                    width="100%",
                    autofocus=true,
                    align="start",
                    v-if="selectedTab === 'products'"
                )
                ib-field(
                    v-model="selectedProduct",
                    @input="checkValidation(selectedProduct)",
                    class="ticker-field mb50",
                    uppercase=true,
                    width="100%",
                    autofocus=true,
                    align="start",
                    v-if="selectedTab === 'contracts'"
                )
                span(class="icons", @click="clearField(true)", v-if="selectedProduct.length > 0")
                    +icon-basic-cancel
                button(class="icons", @click="getResults", v-if="selectedProduct.length === 0")
                    +icon-basic-search_filled
            div(v-if="selectedProduct.length", :class="{ results: isActive }")
                div
                    div(
                        v-for="(result, index) in productSearchResults", 
                        :key="result.conid", v-if="showResults", 
                        class="products_dropdown insety-8 insetx-16",
                        @click="viewDetails(result.companyHeader, result.conid, result.conid, 'all')"
                    )
                        span(class="product-symbol")
                            span {{ result.symbol }}
                        span(class="pointer product-item", :class="{'insetx-32' : $media.m}")
                            span(class="item bold") {{ result.companyHeader }} - {{ result.description }}
                    ib-button(
                        v-if="showResults && moreResults.length > 5 && productSearchResults.length < 6",
                        class="more-results pointer fg-accent",
                        @click="showMoreProducts",
                    )
                        span More Results
                    div(v-if="noSuggestions")
                        p(class="suggestions") No results for "{{ selectedProduct }}"
        ib-col(
            v-if="selectedTab === 'exchanges'",
            class="xl9 search-bar"
        )
            div(class="ticker flex-flex")
                ib-field(
                    v-model="selectedExchange",
                    class="ticker-field mb50",
                    :placeholder="$t('optional')",
                    uppercase=true,
                    width="100%",
                    autofocus=true,
                    align="start"
                )
                span(class="icons", @click="clearField(true)", v-if="selectedExchange.length > 0")
                    +icon-basic-cancel
                button(class="icons", @click="getResults", v-if="selectedExchange.length === 0")
                    +icon-basic-search_filled
            div(:class="{ results: isActive }", v-if="showResults")
                li(v-for="result in exchangeSearchResults", :key="result.symbol", @click="selectExchange(result)") {{ result }}
    SearchProducts(ref='searchProducts')
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";
    import cloneDeep from 'lodash.clonedeep';
    import SearchProducts from './SearchProducts.vue';
    import api from '../api/index.js'

    export default {    
        name: 'Search',
        components: {
            SearchProducts,
        },
        data () {
            return {
                exchangeSearchResults: [],
                showResults: false,  
                isActive: false,
                invalidInput: false,
                showItems: false,
                productSearchResults: [],
                moreResults: [],
                filteredProducts: [],
                noSuggestions: false,
                timeout: null,
                apiResponse: '',
            }
        },
        watch: {
            selectedExchange(newValue, oldValue){
                if(newValue.length === 0) {
                    this.showResults = false;
                    this.setUserSelection(false);
                    this.exchangeSearchResults = [];
                    this.isActive = false;
                    this.setSelectedExchange('');
                } else if(newValue.length > 2 && this.userSelection === false){
                    this.showResults = true;
                    this.isActive = true;

                    // Populating exchange search suggestions
                    this.exchangeSearchResults = [];
                    this.exchanges.forEach(exchange => {
                        if(exchange.id.includes(newValue)){
                            if(!this.exchangeSearchResults.includes(exchange.id)){
                                this.exchangeSearchResults.push(exchange.id);
                            }
                        }
                        if(exchange.name.toUpperCase().includes(newValue)) {
                            if(!this.exchangeSearchResults.includes(exchange.name)){
                                this.exchangeSearchResults.push(exchange.name);
                            }
                        }
                    })
                } else if((this.selectedExchange != newValue) && this.userSelection === true && newValue.length > 2){
                    this.showResults = true;
                    this.isActive = true;
                    // Populating exchange search suggestions
                    this.exchangeSearchResults = [];
                    this.exchanges.forEach(exchange => {
                        if(exchange.id.includes(newValue)){
                            this.exchangeSearchResults.push(exchange.id);
                        }
                        if(exchange.name.toUpperCase().includes(newValue)) {
                            this.exchangeSearchResults.push(exchange.name);
                        }
                    })
                }
            },
            selectedProduct(newValue, oldValue){
                // Restrictions for Japan
                let restrictedSymbols = this.restrictedProducts.map(product => product.symbol); 
                let restrictedDescription = this.restrictedProducts.map(product => product.description.toUpperCase());
                if(newValue.length === 0) {
                    this.isActive = false;
                    this.showResults = false;
                    this.productSearchResults = [];
                    this.noSuggestions = false;
                } else if(this.searchProductType.length === 1 && ['FUT', 'FOP', 'OPT'].includes(this.searchProductType[0]) && this.selectedDomain === 'jp') {
                    if(restrictedSymbols.includes(newValue) || restrictedDescription.includes(newValue)) {
                        $alert("No Results found");
                        this.reset();
                    }
                }
            },
            searchProductType(newValue, oldValue){
                if(this.selectedDomain === 'jp'){
                    let restrictedSymbols = this.restrictedProducts.map(product => product.symbol); 
                    let restrictedDescription = this.restrictedProducts.map(product => product.description.toUpperCase());
                    if(newValue.length === 1 && ['FUT', 'FOP', 'OPT'].includes(newValue[0])) {
                        if(restrictedSymbols.includes(this.selectedProduct) || restrictedDescription.includes(this.selectedProduct)) {
                            $alert("No Results found");
                            this.selectedProduct 
                            this.reset();
                        }
                    }
                }
            },
            showItems(newValue, oldValue) {
                if(newValue === true) {
                    this.productSearchResults = this.moreResults;
                }
            },
        },
        methods: {
            selectExchange(result){
                this.setUserSelection(true);
                this.setSelectedExchange(result);
                if(this.selectedExchange.length > 2 &&  this.userSelection === true) {
                    this.showResults = !this.showResults;
                }
            },
            getResults() {
                if (this.selectedTab != 'contracts') {
                    if (this.preventSearch === true || (this.selectedTab === 'products' && this.selectedProduct === '' && this.selectedProductTypes.length === 0)) {
                        return;
                    } else {
                        window.scrollTo(0, 0);
                        this.search();
                    }
                }
            },
            clearField(bool){
                Vue.nextTick(() => {
                    this.setSelectedExchange('');
                    this.setSelectedProduct('');
                    this.setUserSelection(false);
                    this.productSearchResults = [];
                    this.moreResults = [];
                    this.showItems = false;
                });
            },
            checkValidation(val) {
                this.invalidInput = /[^a-zA-Z,\d\s:.&']/g.test(val) ? true : false;
                if (this.invalidInput) {
                    val = '';
                    this.clearField(true);
                    this.setPreventSearch(true);
                    if (this.selectedTab === 'products') {
                        this.$alert("Input a valid product name");
                    } else {
                        this.$alert("Input a valid exchange or product name");
                    }
                } else {
                    this.setPreventSearch(false);
                }
            },
            showMoreProducts() {
                this.showItems = true;
            },
            viewDetails(companyHeader, conid, underConid, type) {
                this.$refs.searchProducts.open(companyHeader, conid, underConid, type);
            },
            showSuggestions(newValue) {
                this.showResults = false;
                this.showItems = false;
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.filteredProducts = [];
                    this.moreResults = [];
                    this.productSearchResults = [];
                    this.noSuggestions = false;
                    if(this.selectedTab === 'contracts'){
                        this.showResults = true;
                        this.isActive = true;
                        if(newValue.length != 0){
                            if(this.selectedDomain === 'jp'){
                                if(this.i158Restrictions.length != 0) {
                                    this.getSuggestions(newValue);
                                }
                            } else {
                                this.getSuggestions(newValue);
                            }
                        }
                    }
                }, 500)
            },
            getSuggestions(newValue){
                api.getProducts(newValue)
                    .then(response => {
                        response.forEach(res => {
                            res.sections.forEach(section => {
                                if(section.secType === 'STK'){
                                    if(!this.filteredProducts.includes(res) && !this.i158Restrictions.includes(res.conid)){
                                        this.filteredProducts.push(res);
                                    }
                                }
                            })
                        })
                        if(this.filteredProducts.length === 0){
                            this.noSuggestions = true;
                        }
                        this.apiResponse = this.filteredProducts;
                        this.moreResults = this.filteredProducts;
                        this.productSearchResults = this.apiResponse.slice(0,5);
                        this.isActive = true;
                    })
                    .catch((error) => {
                        console.log('Search API service not available')
                        $alert("Product is restricted for IBSJ accounts. Please try new search");
                    })
            },
            ...mapActions(['setPreventSearch', 'setSelectedProduct','setSelectedExchange', 'search', 'setApiTestResponse', 'setUserSelection', 'reset'])
        },
        computed: {
            selectedExchange: {
                get: function() {
                    return this.$store.state.selectedExchange;
                },
                set: function(newValue) {
                    this.setSelectedExchange(newValue);
                }
            },
            selectedProduct: {
                get: function() {
                    return this.$store.state.selectedProduct;
                },
                set: function(newValue) {
                    this.setSelectedProduct(newValue);
                    this.showSuggestions(newValue);
                }
            },
            ...mapGetters(['selectedDomain', 'selectedProductTypes']),
            ...mapState(['selectedTab', 'preventSearch', 'exchanges', 'apitestResponse', 'restrictedProductTypes', 'userSelection', 'restrictedProducts', 'searchProductType', 'i158Restrictions']),
        },
    }
</script>

<style lang="less" scoped>
#search {
    .ticker {
        .ticker-field {
            margin-right: 0;
            font-family: "Proxima Nova", Verdana, Arial, sans-serif;
            cursor: pointer;
            &:hover {
                border-color: #000;
            }
        }
        .icons {
            position: absolute;
            right: 0px;
            border: none;
            background-color: transparent;
            padding-top: 9px;
            padding-right: 9px;
            color: #999;
            cursor: pointer;
        }
    }
    button {
        border-radius: 0;
    }
}
.results {
    list-style: none;
    margin: 5px;
    padding: 0px;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
}
.results li {
    margin: 3px;
    &:hover{
        background-color: #b3c9eb;
        cursor: pointer;
        padding: 2px 2px;
    }
}
.products_dropdown {
    color: #0b56bf;
    &:hover{
        background-color: #b3c9eb;
        cursor: pointer;
    }
}
.search-bar {
    padding-top: 10px;
}
.hover-black {
    &:hover {
        color: #000;
    }
}
.product-item {
    display: inline-block;
    width: 90%;
    margin: 0;
}
.product-symbol {
    display: inline-block;
    width: 10%;
}
.more-results{
    border: none;
    padding: 0px;
    padding-left: 12px;
    &:hover{
        text-decoration: underline;
    }
}
.suggestions{
    padding: 5px;
    text-align: center;
    color: #0b56bf;
}

@media (max-width: 567px) {
    .product-symbol {
        width: 100%;
    }
    .product-item {
        width: 100%;
    }
}
</style>